import PropTypes from 'prop-types';
import VideoProp from './VideoProp';
import { PLAN_TYPES, LICENSE_TYPES } from '../../../services/utilityFunctions';

const propType = {
  _id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  type: PropTypes.oneOf(PLAN_TYPES).isRequired,
  licenseType: PropTypes.oneOf(LICENSE_TYPES).isRequired,
  interval: PropTypes.string.isRequired,
  tiersUsers: PropTypes.arrayOf(
    PropTypes.shape({
      flatAmount: PropTypes.number,
      unitAmount: PropTypes.number,
      minimumRange: PropTypes.number,
      maximumRange: PropTypes.number,
    }),
  ).isRequired,
  tiersAdmins: PropTypes.arrayOf(
    PropTypes.shape({
      flatAmount: PropTypes.number,
      unitAmount: PropTypes.number,
      minimumRange: PropTypes.number,
      maximumRange: PropTypes.number,
    }),
  ).isRequired,
  video: PropTypes.shape(VideoProp.propType).isRequired,
};

export default { propType };
